// import { Logger } from '@vue-storefront/core';
// const cookie = require("cookie");
import {
  VSF_LOCALE_COOKIE,
  VSF_CURRENCY_COOKIE
} from "@vue-storefront/core";
import { useSystemStore } from '~/stores/system';
// // // 序列化cookie
// import i18nConfig from "@/i18nConfig";
// const seriCookie = (cookieObject) => {
//   const cookieStrings = [];
//   for (const key in cookieObject) {
//     const serializedCookie = cookie.serialize(key, cookieObject[key]);
//     cookieStrings.push(serializedCookie);
//   }
//   return cookieStrings.join("; ");
// };
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export default async (context) => {
  const { $cookies, app } = context;
  const systemStore = useSystemStore();
  if (app?.$mallConfig?.mall_currency) {
    const currency1 = $cookies.get(VSF_CURRENCY_COOKIE);
    const index = app.$mallConfig.mall_currency.indexOf(currency1);
    if (index === -1 && app?.defaultView) {
      $cookies.set(VSF_CURRENCY_COOKIE, app?.defaultView?.currency, {
        path: "/",
        sameSite: "Lax",
        maxAge: 3600 * 24 * 365
      });
    }
  }
  if (process.server) {
    const userAgent = context.req?.headers['user-agent'] || '';
    const isMobile = /mobile|android|iphone|ipad/i.test(userAgent.toLowerCase());
    systemStore.setDeviceType(isMobile);
    app.$vsf.$xbuy.client.defaults.headers.cookie = context.req.headers.cookie;
    app.$vsf.$xbuy.config.axios.headers.cookie = context.req.headers.cookie;
    // const path = context.route.path;
    // const regex = /^\/([\w-]+)/;
    // const match = path.match(regex);
    // const parsedCookies = cookie.parse(context.req?.headers.cookie || "") || {};
    // console.log("---------parsedCookies", parsedCookies, app.$viewList)
    // const setCookies = (k, v) => {
    //   parsedCookies[k] = v;
    //   context.req.headers.cookie = seriCookie(parsedCookies);
    //   app.$vsf.$xbuy.client.defaults.headers.cookie = seriCookie(parsedCookies);
    //   app.$vsf.$xbuy.config.axios.headers.cookie = seriCookie(parsedCookies);
    // };
    // // console.log("match", context.req.headers.cookie, path, match);
    // if (match && match[1] && match[1].length === 5 && match[1].indexOf('-') === 2) {
    //   setCookies(VSF_LOCALE_COOKIE, match[1]);
    // } else {
    //   const defaultView = viewList?.find((item) => {
    //     return item.isDefault === 1;
    //   });
    //   setCookies(VSF_LOCALE_COOKIE, defaultView.lang);
    //   setCookies(VSF_CURRENCY_COOKIE, defaultView.currency);
    // }
    // console.log("设置后的cookie", app.$vsf.$xbuy.config.axios.headers.cookie);
    // }
    // 打印cookies
    // 购物车流程判断
    // const currentPath = app.context.route.fullPath.split('/checkout/')[1];
    // if (!currentPath) return;

    // const redirectWithLocalePath = (path) => {
    //   app.context.redirect(app.localePath(path));
  };

  // const canEnterShipping = true;
  // const canEnterBilling = canEnterShipping && true;
  // const canEnterPayment = canEnterBilling && true;
  // switch (currentPath) {
  //   case 'shipping':
  //     if (canEnterShipping) return;
  //     redirectWithLocalePath('/');
  //     break;
  //   case 'billing':
  //     if (canEnterBilling) return;
  //     redirectWithLocalePath('/checkout/shipping');
  //     break;
  //   case 'payment':
  //     if (canEnterPayment) return;
  //     if (canEnterBilling) return redirectWithLocalePath('/checkout/billing');
  //     redirectWithLocalePath('/checkout/shipping');
  //     break;
  // }
};
